export const formatDate = (dateString: string) => {
  const options = {
    day: "numeric",
    month: "long",
    year: "numeric",
  } as const;
  const date = new Date(dateString);
  return date.toLocaleDateString("en", options);
};
